import React, { useState } from 'react';
import { ShieldAlert, Filter, Users, CheckCircle2, XCircle, Eye, EyeOff, Tag, BarChart } from 'lucide-react';
const contentItems = [{
  id: 1,
  title: 'Morning Shower Routine',
  date: '2023-05-15',
  isNSFW: true,
  ageRestricted: true,
  isPremium: true,
  views: 24500,
  reach: 18300,
  engagement: 9.2,
  label: 'NSFW Shower Scene'
}, {
  id: 2,
  title: 'Bedroom Talk ASMR',
  date: '2023-05-10',
  isNSFW: true,
  ageRestricted: true,
  isPremium: false,
  views: 18900,
  reach: 15200,
  engagement: 7.8,
  label: 'NSFW Audio'
}, {
  id: 3,
  title: 'Try-on Haul',
  date: '2023-05-05',
  isNSFW: true,
  ageRestricted: true,
  isPremium: true,
  views: 32100,
  reach: 28400,
  engagement: 12.5,
  label: 'Premium Lingerie'
}, {
  id: 4,
  title: 'Q&A with Fans (Live)',
  date: '2023-05-01',
  isNSFW: false,
  ageRestricted: false,
  isPremium: false,
  views: 15800,
  reach: 15800,
  engagement: 8.1,
  label: 'Safe for Work'
}, {
  id: 5,
  title: 'Yoga Session',
  date: '2023-04-28',
  isNSFW: false,
  ageRestricted: false,
  isPremium: false,
  views: 12400,
  reach: 12400,
  engagement: 6.5,
  label: 'Safe for Work'
}, {
  id: 6,
  title: 'Interactive Toy Review',
  date: '2023-04-25',
  isNSFW: true,
  ageRestricted: true,
  isPremium: true,
  views: 28700,
  reach: 21500,
  engagement: 11.2,
  label: 'NSFW Toy Review'
}, {
  id: 7,
  title: 'Premium Shower Scene',
  date: '2023-04-20',
  isNSFW: true,
  ageRestricted: true,
  isPremium: true,
  views: 31200,
  reach: 23400,
  engagement: 13.8,
  label: 'Premium Shower Scene'
}];
export function NSFWControlsSection() {
  const [filter, setFilter] = useState('all');
  const filteredContent = filter === 'all' ? contentItems : filter === 'nsfw' ? contentItems.filter(item => item.isNSFW) : contentItems.filter(item => !item.isNSFW);
  const nsfwCount = contentItems.filter(item => item.isNSFW).length;
  const sfwCount = contentItems.filter(item => !item.isNSFW).length;
  const totalViews = contentItems.reduce((sum, item) => sum + item.views, 0);
  const nsfwViews = contentItems.filter(item => item.isNSFW).reduce((sum, item) => sum + item.views, 0);
  const nsfwViewPercentage = Math.round(nsfwViews / totalViews * 100);
  const restrictedReach = contentItems.filter(item => item.isNSFW).reduce((sum, item) => sum + (item.views - item.reach), 0);
  const restrictedReachPercentage = Math.round(restrictedReach / nsfwViews * 100);
  return <div className="w-full space-y-6" data-id="element-5151">
      {/* Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5152">
        <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-5153">
          <div className="flex items-center justify-between mb-4" data-id="element-5154">
            <h4 className="text-md font-semibold" data-id="element-5155">Content Breakdown</h4>
            <ShieldAlert className="w-5 h-5 text-red-500" data-id="element-5156" />
          </div>
          <div className="flex items-center justify-center space-x-4" data-id="element-5157">
            <div className="text-center" data-id="element-5158">
              <div className="text-3xl font-bold" data-id="element-5159">{nsfwCount}</div>
              <div className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-5160">
                NSFW Content
              </div>
            </div>
            <div className="text-center" data-id="element-5161">
              <div className="text-3xl font-bold" data-id="element-5162">{sfwCount}</div>
              <div className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-5163">
                SFW Content
              </div>
            </div>
          </div>
          <div className="mt-4" data-id="element-5164">
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700" data-id="element-5165">
              <div className="bg-red-600 h-2.5 rounded-full" style={{
              width: `${nsfwCount / contentItems.length * 100}%`
            }} data-id="element-5166"></div>
            </div>
            <div className="flex justify-between mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-5167">
              <span data-id="element-5168">
                {Math.round(nsfwCount / contentItems.length * 100)}% NSFW
              </span>
              <span data-id="element-5169">
                {Math.round(sfwCount / contentItems.length * 100)}% SFW
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-5170">
          <div className="flex items-center justify-between mb-4" data-id="element-5171">
            <h4 className="text-md font-semibold" data-id="element-5172">Age-Restricted Reach</h4>
            <Users className="w-5 h-5 text-blue-500" data-id="element-5173" />
          </div>
          <div className="text-center mb-4" data-id="element-5174">
            <div className="text-3xl font-bold" data-id="element-5175">
              {restrictedReachPercentage}%
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-5176">
              Reduced Reach Due to Age Restriction
            </div>
          </div>
          <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg text-sm" data-id="element-5177">
            <p data-id="element-5178">
              Your NSFW content reaches {100 - restrictedReachPercentage}% of
              your potential audience due to age restrictions.
            </p>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-5179">
          <div className="flex items-center justify-between mb-4" data-id="element-5180">
            <h4 className="text-md font-semibold" data-id="element-5181">NSFW Performance</h4>
            <BarChart className="w-5 h-5 text-purple-500" data-id="element-5182" />
          </div>
          <div className="text-center mb-4" data-id="element-5183">
            <div className="text-3xl font-bold" data-id="element-5184">{nsfwViewPercentage}%</div>
            <div className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-5185">
              Of Total Views from NSFW Content
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 mt-4" data-id="element-5186">
            <div className="p-2 bg-gray-50 dark:bg-gray-700 rounded-lg text-center" data-id="element-5187">
              <div className="text-lg font-bold" data-id="element-5188">
                {Math.round(nsfwViews / nsfwCount).toLocaleString()}
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-5189">
                Avg. NSFW Views
              </div>
            </div>
            <div className="p-2 bg-gray-50 dark:bg-gray-700 rounded-lg text-center" data-id="element-5190">
              <div className="text-lg font-bold" data-id="element-5191">11.5%</div>
              <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-5192">
                Avg. NSFW Engagement
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Content Management */}
      <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-5193">
        <div className="flex items-center justify-between mb-4" data-id="element-5194">
          <h4 className="text-md font-semibold" data-id="element-5195">NSFW Content Management</h4>
          <div className="flex items-center space-x-2" data-id="element-5196">
            <button className={`px-3 py-1 text-sm rounded-md ${filter === 'all' ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300'}`} onClick={() => setFilter('all')} data-id="element-5197">
              All
            </button>
            <button className={`px-3 py-1 text-sm rounded-md ${filter === 'nsfw' ? 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300'}`} onClick={() => setFilter('nsfw')} data-id="element-5198">
              NSFW Only
            </button>
            <button className={`px-3 py-1 text-sm rounded-md ${filter === 'sfw' ? 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300'}`} onClick={() => setFilter('sfw')} data-id="element-5199">
              SFW Only
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-5200">
          <table className="w-full" data-id="element-5201">
            <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-5202">
              <tr data-id="element-5203">
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-5204">
                  Title
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-5205">
                  Date
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-5206">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-5207">
                  Label
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-5208">
                  Views
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-5209">
                  Reach
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-5210">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-600" data-id="element-5211">
              {filteredContent.map(item => <tr key={item.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50" data-id="element-5212">
                  <td className="px-4 py-4 whitespace-nowrap text-sm font-medium" data-id="element-5213">
                    {item.title}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-5214">
                    {item.date}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-5215">
                    {item.isNSFW ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200" data-id="element-5216">
                        NSFW
                      </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-5217">
                        SFW
                      </span>}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-5218">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200" data-id="element-5219">
                      {item.label}
                    </span>
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-5220">
                    {item.views.toLocaleString()}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-5221">
                    {item.reach.toLocaleString()}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-5222">
                    <div className="flex items-center space-x-2" data-id="element-5223">
                      <button className="p-1 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-5224">
                        <Eye className="w-4 h-4 text-gray-500" data-id="element-5225" />
                      </button>
                      <button className="p-1 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-5226">
                        <Tag className="w-4 h-4 text-gray-500" data-id="element-5227" />
                      </button>
                      <button className="p-1 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-5228">
                        <Filter className="w-4 h-4 text-gray-500" data-id="element-5229" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      {/* Compliance and Settings */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5230">
        <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-5231">
          <h4 className="text-md font-semibold mb-4" data-id="element-5232">
            Age Verification Status
          </h4>
          <div className="p-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg flex items-start" data-id="element-5233">
            <CheckCircle2 className="w-6 h-6 text-green-500 mr-3 flex-shrink-0" data-id="element-5234" />
            <div data-id="element-5235">
              <h5 className="font-medium text-green-700 dark:text-green-400" data-id="element-5236">
                18+ Compliant
              </h5>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1" data-id="element-5237">
                Your account has proper age verification measures in place. All
                NSFW content is properly flagged and restricted to verified 18+
                users.
              </p>
            </div>
          </div>
          <div className="mt-4 space-y-3" data-id="element-5238">
            <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-5239">
              <div className="flex items-center" data-id="element-5240">
                <Users className="w-5 h-5 text-gray-500 mr-2" data-id="element-5241" />
                <span className="text-sm" data-id="element-5242">Age Verification Required</span>
              </div>
              <div className="relative inline-flex items-center" data-id="element-5243">
                <input type="checkbox" value="" className="sr-only peer" checked readOnly data-id="element-5244" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600" data-id="element-5245"></div>
              </div>
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-5246">
              <div className="flex items-center" data-id="element-5247">
                <EyeOff className="w-5 h-5 text-gray-500 mr-2" data-id="element-5248" />
                <span className="text-sm" data-id="element-5249">Auto-Blur NSFW Thumbnails</span>
              </div>
              <div className="relative inline-flex items-center" data-id="element-5250">
                <input type="checkbox" value="" className="sr-only peer" checked readOnly data-id="element-5251" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600" data-id="element-5252"></div>
              </div>
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-5253">
              <div className="flex items-center" data-id="element-5254">
                <ShieldAlert className="w-5 h-5 text-gray-500 mr-2" data-id="element-5255" />
                <span className="text-sm" data-id="element-5256">Auto-Tag NSFW Content</span>
              </div>
              <div className="relative inline-flex items-center" data-id="element-5257">
                <input type="checkbox" value="" className="sr-only peer" checked readOnly data-id="element-5258" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600" data-id="element-5259"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-5260">
          <h4 className="text-md font-semibold mb-4" data-id="element-5261">
            Top Performing NSFW Content
          </h4>
          <ul className="space-y-3" data-id="element-5262">
            <li className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-5263">
              <div className="flex items-center" data-id="element-5264">
                <div className="w-10 h-10 bg-purple-100 dark:bg-purple-900 rounded-md flex items-center justify-center mr-3" data-id="element-5265">
                  <span className="text-purple-600 dark:text-purple-300 font-bold" data-id="element-5266">
                    1
                  </span>
                </div>
                <div data-id="element-5267">
                  <h5 className="font-medium" data-id="element-5268">Premium Shower Scene</h5>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-5269">
                    31.2K views • 13.8% engagement
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-1" data-id="element-5270">
                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200" data-id="element-5271">
                  NSFW
                </span>
                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200" data-id="element-5272">
                  Premium
                </span>
              </div>
            </li>
            <li className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-5273">
              <div className="flex items-center" data-id="element-5274">
                <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-md flex items-center justify-center mr-3" data-id="element-5275">
                  <span className="text-blue-600 dark:text-blue-300 font-bold" data-id="element-5276">
                    2
                  </span>
                </div>
                <div data-id="element-5277">
                  <h5 className="font-medium" data-id="element-5278">Interactive Toy Review</h5>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-5279">
                    28.7K views • 11.2% engagement
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-1" data-id="element-5280">
                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200" data-id="element-5281">
                  NSFW
                </span>
                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200" data-id="element-5282">
                  Premium
                </span>
              </div>
            </li>
            <li className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-5283">
              <div className="flex items-center" data-id="element-5284">
                <div className="w-10 h-10 bg-green-100 dark:bg-green-900 rounded-md flex items-center justify-center mr-3" data-id="element-5285">
                  <span className="text-green-600 dark:text-green-300 font-bold" data-id="element-5286">
                    3
                  </span>
                </div>
                <div data-id="element-5287">
                  <h5 className="font-medium" data-id="element-5288">Try-on Haul</h5>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-5289">
                    32.1K views • 12.5% engagement
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-1" data-id="element-5290">
                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200" data-id="element-5291">
                  NSFW
                </span>
                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200" data-id="element-5292">
                  Premium
                </span>
              </div>
            </li>
          </ul>
          <div className="mt-4 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg" data-id="element-5293">
            <h5 className="font-medium text-yellow-700 dark:text-yellow-400 flex items-center" data-id="element-5294">
              <ShieldAlert className="w-5 h-5 mr-2" data-id="element-5295" />
              Content Advisory
            </h5>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1" data-id="element-5296">
              NSFW content performs 35% better than SFW content for your
              audience. Consider creating more premium NSFW content while
              maintaining compliance.
            </p>
          </div>
        </div>
      </div>
    </div>;
}